import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppInitService } from './app/app-init.service';
import { ServiceAccessDisabledModule } from './app/service-access-disabled/service-access-disabled.module';

if (environment.production) {
  enableProdMode();
}

async function bootstrapApplication() {
  const appInitService = AppInitService.createInstance();
  const isServiceAccessEnable = await appInitService.init();

  const moduleToLoad = isServiceAccessEnable ? AppModule : ServiceAccessDisabledModule;

  platformBrowserDynamic().bootstrapModule(moduleToLoad)
    .catch(err => console.error(err));
}

bootstrapApplication();
